import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getZeroCarbonLetters } from '~/services/ZeroCarbon';
import { Pagination } from '~/types';
import { PAGE_SIZE } from '~/constants';
import { ZeroCarbonLetter } from '~/types/zeroCarbon';

export function useZeroCarbonLetters(
  page: number,
  size = PAGE_SIZE,
  options: UseQueryOptions<Pagination<ZeroCarbonLetter>, unknown> = {},
): UseQueryResult<Pagination<ZeroCarbonLetter>, unknown> {
  return useQuery<Pagination<ZeroCarbonLetter>, unknown>(
    ['zero_carbon_letters', page],
    () => getZeroCarbonLetters(page, size),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
